'use client'

import { useEffect, useState } from 'react'
import PageLoadEvent from '@components/HomePage/utils/pageLoadEvent'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'

const NewBlogPageLoadEvent = () => {
  const [properties, setProperties] = useState<object | null>(null)

  useEffect(() => {
    void segmentEventCommonPropFunc({}).then(setProperties)
  }, [])

  if (!properties) return null

  return <PageLoadEvent viewEventName="view_seo_page" properties={properties} />
}

export default NewBlogPageLoadEvent
